import axios from 'axios';
import * as Sentry from '@sentry/react';
import { API_BASE_URL } from '../utils/constants';
import { getToken } from './auth';

/**
 * Centralized API client for Thaklis application
 * Uses environment variables for API URL configuration
 * Automatically includes authentication tokens for all requests
 */
const apiClient = axios.create({
  // Use absolute API base to align with server CORS config and previous behavior
  baseURL: API_BASE_URL,
});

// Add a request interceptor to include auth token in all requests
apiClient.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle common errors
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle common errors like 401 (Unauthorized), etc.
    if (error.response && error.response.status === 401) {
      console.error('Authentication error: Token may be expired');
    }
    // Capture 5xx errors and network failures to Sentry
    if (error.response && error.response.status >= 500) {
      Sentry.captureException(error, {
        tags: { api_status: error.response.status, api_url: error.config?.url },
        extra: { response_data: error.response.data, method: error.config?.method },
      });
    } else if (!error.response) {
      Sentry.captureException(error, {
        tags: { error_type: 'network_error' },
        extra: { url: error.config?.url },
      });
    }
    return Promise.reject(error);
  }
);

export default apiClient;
